var Client = require('./lib/client');

module.exports = new Client();
